import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'plano-cargo-salario',
  templateUrl: './plano-cargo-salario.component.html',
  styleUrls: ['./plano-cargo-salario.component.css']
})
export class PlanoCargoSalarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
